import React from "react"
import * as S from "./solutions-scrollable.styles"
import { Container, Grid } from "@mui/material"
import parse from "html-react-parser"
import { FadeOverlay } from "./solutions-scrollable.styles"

const SolutionsScrollable = ({ bgPattern, topTitle, description, items }) => {
  return (
    <S.Section img={bgPattern}>
      <Container maxWidth="xl">
        <Grid container spacing={{ xs: 7.5, sm: 10, md: 15, lg: 20 }}>
          <Grid item xs={12} md={6} style={{ position: "relative" }}>
            <S.LeftWrapper>
              <S.Title>{topTitle}</S.Title>
              {description && (
                <S.Description>{parse(description)}</S.Description>
              )}
            </S.LeftWrapper>
          </Grid>
          <Grid item xs={12} md={6}>
            <S.RightWrapper>
              <S.FadeOverlay/>
              {items?.map((item, index) => (
                <S.ItemWrapper key={`item-${index}`}>
                  <S.ItemImage
                    img={item.image}
                    alt={item.title}
                    className="image"
                  />
                  <S.ItemTitle>{item.title}</S.ItemTitle>
                  <S.ItemDescription>
                    {parse(item.description)}
                  </S.ItemDescription>
                </S.ItemWrapper>
              ))}
            </S.RightWrapper>
          </Grid>
        </Grid>
      </Container>
    </S.Section>
  )
}

export default SolutionsScrollable
